import _sfc_main from "./MemberInfo.vue2.mjs";
/* empty css                 */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_setup.isMobile ? "member-info-mobile" : "member-info"] }, [_c("div", { class: !_vm.showStateIcon && _setup.isTargetUserAdmin ? "member-basic-info-admin" : "member-basic-info" }, [_c(_setup.Avatar, { staticClass: "avatar-url", attrs: { "img-src": _vm.userInfo.avatarUrl } }), _c("div", { staticClass: "user-name" }, [_vm._v(_vm._s(_setup.roomService.getDisplayName(_vm.userInfo)))]), _c("div", { staticClass: "role-info" }, [_setup.isTargetUserRoomOwner || _setup.isTargetUserAdmin ? _c(_setup.SvgIcon, { class: _setup.isTargetUserAdmin ? "admin-icon" : "master-icon", attrs: { "icon": _setup.UserIcon, "color": _setup.isTargetUserAdmin ? "#F06C4B" : "#4791FF" } }) : _vm._e(), _c("div", { class: `user-extra-info ${_setup.isTargetUserAdmin ? "user-extra-info-admin" : ""}` }, [_vm._v(" " + _vm._s(_setup.extraInfo) + " ")])], 1)], 1), _vm.showStateIcon ? _c("div", { staticClass: "member-av-state" }, _vm._l(_setup.iconList, function(item, index) {
    return _c(_setup.SvgIcon, { key: index, class: ["state-icon", { "disable-icon": item.disable }], attrs: { "icon": item.icon, "size": item.size } });
  }), 1) : _vm._e(), _c(_setup.MemberInvite, { directives: [{ name: "show", rawName: "v-show", value: !_setup.props.userInfo.isInRoom, expression: "!props.userInfo.isInRoom" }], staticClass: "member-invite", attrs: { "user-info": _setup.props.userInfo } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "3e8cd65d"
);
const MemberInfo = __component__.exports;
export {
  MemberInfo as default
};
